import { accountContract as s } from "@hprofits/api/account";
import { adGroupContract as m } from "@hprofits/api/ad-group";
import { adUnitContract as p } from "@hprofits/api/ad-unit";
import { arbitrageModelRuleContract as l } from "@hprofits/api/arbitrage-model-rule";
import { authContract as u } from "@hprofits/api/auth";
import { blacklistAutoRuleContract as d } from "@hprofits/api/blacklist-auto-rule";
import { campaignContract as f } from "@hprofits/api/campaign";
import { creativeGroupContract as g } from "@hprofits/api/creative-group";
import { dashboardContract as C } from "@hprofits/api/dashboard/contract";
import { dictionaryContract as b } from "@hprofits/api/dictionary";
import { domainsContract as R } from "@hprofits/api/domains";
import { goalContract as h } from "@hprofits/api/goal/contract";
import { rotatorCampaignContract as v } from "@hprofits/api/rotator-campaign/contract";
import { statisticsContract as G } from "@hprofits/api/statistics";
import { syndicationDomainContract as w } from "@hprofits/api/syndication-domain/contract";
import { targetGroupContract as y } from "@hprofits/api/target-group";
import { userContract as k } from "@hprofits/api/user/contract";
import { createORPCClient as A } from "@orpc/client";
import { RequestValidationPlugin as P, ResponseValidationPlugin as D } from "@orpc/contract/plugins";
import { OpenAPILink as E } from "@orpc/openapi-client/fetch";
import { ErrorNormalizationPlugin as L } from "./plugins/error-normalization/error-normalization.js";
import { toTransportError as M } from "./to-transport-error.js";
const a = {
  ...s,
  ...m,
  ...p,
  ...l,
  ...u,
  ...d,
  ...f,
  ...g,
  ...C,
  ...R,
  ...b,
  ...h,
  ...v,
  ...G,
  ...w,
  ...y,
  ...k
}, U = async (r) => r ? typeof r == "function" ? r() : r : {}, tt = (r) => {
  const e = async (i, n) => {
    try {
      return await (r.fetch ?? globalThis.fetch)(i, n);
    } catch (o) {
      throw o instanceof Error || o instanceof DOMException ? M(o, i, n) : o;
    }
  }, c = new E(a, {
    url: r.baseURL,
    headers: () => U(r.headers),
    fetch: e,
    plugins: [
      new L(),
      new P(a),
      new D(a)
    ]
  }), t = A(c);
  return {
    account: t.account,
    adGroup: t.adGroup,
    adUnit: t.adUnit,
    asset: t.asset,
    session: t.session,
    profile: t.profile,
    captcha: t.captcha,
    registration: t.registration,
    passwordReset: t.passwordReset,
    token: t.token,
    campaign: t.campaign,
    creativeGroup: t.creativeGroup,
    creatives: t.creatives,
    landings: t.landings,
    landingGroups: t.landingGroups,
    advertLabels: t.advertLabels,
    review: t.review,
    dashboard: t.dashboard,
    domains: t.domains,
    pricingRule: t.pricingRule,
    dictionary: t.dictionary,
    goal: t.goal,
    rotatorCampaign: t.rotatorCampaign,
    statistics: t.statistics,
    syndicationDomain: t.syndicationDomain,
    targetGroup: t.targetGroup,
    blacklistAutoRule: t.blacklistAutoRule,
    arbitrageModelRule: t.arbitrageModelRule,
    user: t.user
  };
};
export {
  tt as createApiClient
};
//# sourceMappingURL=client.js.map
